import React from "react";
import {makeStyles} from "@material-ui/styles";

export default makeStyles(theme => {
    return {
        heading: {
            justifyContent: "space-between",
            alignItems:"center",
            "& > div":{
                flexGrow:1,
                display:"flex",
                justifyContent:"flex-end",
                alignItems:"center",
                flexWrap:"wrap"
            }
        },
        [theme.breakpoints.down("xs")]:{
            heading: {
                justifyContent: "flex-start",
                alignItems:"flex-start",
                flexDirection:"column !important",
                "& > div":{
                    display:"flex",
                    justifyContent:"flex-start",
                    alignItems:"flex-start",
                    flexDirection:"column",
                    width: "100%"
                },
                "& .MuiTextField-root":{
                    width: "100%"
                },
                "& button":{
                    marginTop: theme.spacing(1)
                }
            }
        }
    }
})